import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=9fe0a11c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=9fe0a11c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe0a11c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fe0a11c')) {
      api.createRecord('9fe0a11c', component.options)
    } else {
      api.reload('9fe0a11c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=9fe0a11c&scoped=true&", function () {
      api.rerender('9fe0a11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myIntegral/detail.vue"
export default component.exports